import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   graphsContainer: {
      width: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [filtersData, setFiltersData] = useState();
   const [chartData, setChartData] = useState();
   const [MultiTable, setMultiTable] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { filtersData, chartData, MultiTable } = JSON.parse(report);
         setFiltersData(filtersData);
         setChartData(chartData);
         setMultiTable(MultiTable);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const getChartsOptionsDefault = () => {
      let option = {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'cross',
               label: {
                  backgroundColor: '#6a7985',
               },
            },
         },
         legend: {
            data: ['ผู้เข้าใช้งาน', 'ผู้เข้าร่วมกิจกรรม', 'ผู้แลกของรางวัล'],
         },
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               name: 'วัน',
               type: 'category',
               boundaryGap: false,
               data: null,
               axisLabel: { rotate: 45 },
            },
         ],
         yAxis: [
            {
               type: 'value',
            },
         ],
         series: [
            {
               smooth: true,
               name: 'ผู้เข้าใช้งาน',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               smooth: true,
               name: 'ผู้เข้าร่วมกิจกรรม',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               smooth: true,
               name: 'ผู้แลกของรางวัล',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
      return option;
   };
   const mapOptions = (data) => {
      let xAxisDate = data.map((el) => el.dateTimeLabel);
      let loginCount = data.map((el) => el.loginCount);
      let activityCount = data.map((el) => el.activityCount);
      let redemptionCount = data.map((el) => el.redemptionCount);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisDate;
      options.series[0].data = loginCount;
      options.series[1].data = activityCount;
      options.series[2].data = redemptionCount;
      return options;
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>
                  แสดงข้อมูลการใช้งานของพนักงานในแต่ละหน่วยงาน
               </div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     กลุ่ม:{' '}
                     {(filtersData &&
                        filtersData.group &&
                        filtersData.group.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     สายงาน:{' '}
                     {(filtersData &&
                        filtersData.field &&
                        filtersData.field.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     ฝ่าย/ภาค:{' '}
                     {(filtersData &&
                        filtersData.department &&
                        filtersData.department.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     ส่วน/เขต:{' '}
                     {(filtersData &&
                        filtersData.segment &&
                        filtersData.segment.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     งาน/สาขา:{' '}
                     {(filtersData &&
                        filtersData.branch &&
                        filtersData.branch.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className='sub-title'>กราฟ</div>
               <div className={classes.graphsContainer}>
                  {chartData && (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 300, width: '100%' }}
                     />
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[0].listName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อสังกัด</th>
                              <th>ครั้ง</th>
                           </tr>
                           {MultiTable[0].employeeAction.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.name}</td>
                                 <td>{item.count}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className='page' id='2'>
            <div className='subpage'>
               <div>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[1].listName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อสังกัด</th>
                              <th>ครั้ง</th>
                           </tr>
                           {MultiTable[1].employeeAction.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.name}</td>
                                 <td>{item.count}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
               <div style={{ marginTop: '10px' }}>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[2].listName}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>ชื่อสังกัด</th>
                              <th>ครั้ง</th>
                           </tr>
                           {MultiTable[2].employeeAction.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.name}</td>
                                 <td>{item.count}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
